import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ROLE_LABELS } from "../lib/constants";
import { Gauge, UsersRound, TrafficCone, Goal, LandPlot, DoorOpen, Cog } from "lucide-react";
import logo from "../assets/logo.jpg";

const NAV = [
  { to: "/dashboard", label: "الرئيسية", icon: Gauge },
  { to: "/players", label: "اللاعبون", icon: UsersRound },
  { to: "/training", label: "التدريبات", icon: TrafficCone },
  { to: "/matches", label: "المباريات", icon: Goal },
  { to: "/tactics", label: "التشكيلات", icon: LandPlot },
];

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen flex flex-col" dir="rtl">
      {/* top header */}
      <header className="sticky top-0 z-40 border-b border-black/20" style={{ backgroundColor: "#2a3b19" }}>
        <div className="max-w-7xl mx-auto px-4 lg:px-8 h-16 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <img src={logo} alt="modarreb" className="h-10 w-28 object-cover rounded-lg shrink-0" />
            {user?.project?.club_name && (
              <div className="text-xs text-white/70 truncate hidden sm:block border-r border-white/20 pr-3">
                {user.project.club_name}
              </div>
            )}
          </div>

          <div className="flex items-center gap-2">
            <div className="text-left hidden sm:block ml-1">
              <div className="text-sm font-semibold truncate max-w-[160px] text-white">{user?.name}</div>
              <div className="text-[11px] text-white/60">{ROLE_LABELS[user?.role]}</div>
            </div>
            {user?.role === "admin" && (
              <button
                data-testid="nav-admin"
                onClick={() => navigate("/admin")}
                className="p-2.5 rounded-xl text-white hover:bg-white/10 transition-colors"
                title="لوحة المدير"
              >
                <Cog size={20} />
              </button>
            )}
            <button
              data-testid="logout-btn"
              onClick={doLogout}
              className="p-2.5 rounded-xl text-white hover:bg-white/10 transition-colors"
              title="تسجيل الخروج"
            >
              <DoorOpen size={20} />
            </button>
          </div>
        </div>
      </header>

      {/* main content — centered, responsive, room for bottom nav */}
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 lg:px-8 py-6 lg:py-8 pb-32 animate-fade-up">
        {children}
      </main>

      {/* floating bottom navigation */}
      <nav className="fixed bottom-4 inset-x-0 z-40 flex justify-center px-4 pointer-events-none">
        <div className="pointer-events-auto glass border border-[#d1fae5] rounded-2xl shadow-xl flex items-center gap-1 p-1.5">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.slice(1)}`}
              title={n.label}
              className={({ isActive }) =>
                `flex items-center justify-center rounded-xl transition-all duration-200 w-12 h-12 ${
                  isActive
                    ? "bg-[#2a3b19] text-white shadow-md scale-105"
                    : "text-slate-500 hover:text-[#2a3b19] hover:bg-[#ecfdf5]"
                }`
              }
            >
              <n.icon size={22} />
            </NavLink>
          ))}
        </div>
      </nav>
    </div>
  );
}
